import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Job } from '../../../core/services/job/job.model';
import { AuthService } from '../../../core/services/auth.service';

@Component({
  selector: 'app-organization-jobs',
  templateUrl: './organization-jobs.component.html'
})
export class OrganizationJobsComponent {
  @Input() jobs: {
    items: null | Array<{}>;
    count: number;
    amountOfPages: number;
    loading: boolean;
  };

  @Output() loadMore = new EventEmitter<void>();
  // TODO:
  // should be job here, but organization job model, not job.model
  @Output() edit = new EventEmitter<any>();

  constructor(private auth: AuthService) {}

  onEditJob(job) {
    this.edit.emit(job);
  }

  onScrolled() {
    this.loadMore.emit();
  }

  isOwner(job: Job) {
    return this.auth.userID() === job.user_id;
  }
}
